import { PropAsset } from './PropAsset';

// Oak Tree - Meşe Ağacı
// TODO: Replace with SVG asset
export class TreeOak extends PropAsset {
  readonly id = 'tree_oak';
  readonly width = 65;
  readonly height = 95;
  readonly walkable = false;
  readonly collisionRadius = 0.4;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 14 * s, 7 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Trunk - Gövde
    ctx.fillStyle = '#5a4030';
    ctx.fillRect(cx - 5 * s, cy - 30 * s, 10 * s, 30 * s);

    // Main foliage - Ana yaprak kümesi
    const leafColor = _variant === 1 ? '#8b4513' : '#2a5a2a'; // Autumn variant
    ctx.fillStyle = leafColor;

    // Large center blob
    ctx.beginPath();
    ctx.arc(cx, cy - 45 * s, 20 * s, 0, Math.PI * 2);
    ctx.fill();

    // Left blob
    ctx.beginPath();
    ctx.arc(cx - 12 * s, cy - 38 * s, 14 * s, 0, Math.PI * 2);
    ctx.fill();

    // Right blob
    ctx.beginPath();
    ctx.arc(cx + 12 * s, cy - 38 * s, 14 * s, 0, Math.PI * 2);
    ctx.fill();

    // Top blob
    ctx.beginPath();
    ctx.arc(cx, cy - 55 * s, 12 * s, 0, Math.PI * 2);
    ctx.fill();

    // Highlight
    ctx.fillStyle = 'rgba(255,255,255,0.1)';
    ctx.beginPath();
    ctx.arc(cx - 5 * s, cy - 50 * s, 8 * s, 0, Math.PI * 2);
    ctx.fill();
  }
}
